import React from 'react';

import styled from '@emotion/styled';

import { TableComponent } from '../components/TableCom';
import { ModalProvider } from '../context/ModalContext';

const Clearer = () => {
  return (
    <ModalProvider>
      <Container>
        <TableComponent
          tableBaseUrl="general-service/v1/cargos"
          tableLabel="Clearer"
          tableHeader={[
            'id',
            'airWayBillNumber',
            'assignedClearanceAgent',
            'status',
          ]}
          mappingData={{
            id: 'CargoID',
            airWayBillNumber: 'AirwaybillId',
            assignedClearanceAgent: 'Assigned Clearer',
            status: 'Clearance Status',
          }}
        />
      </Container>
    </ModalProvider>
  );
};

export default Clearer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
